<template>
  <div id="shouyiInv">
    <!-- <div class="topmoney whiteB relativeItem">
      <span>邀请获取(个)：</span>
      <span class="money">{{ totalProfit }}</span>
      <router-link class="shouyiInvA absoluteItem centerY radius3" to="/invate">赚获取</router-link>
    </div>-->
    <div id="topshell">
      <img class="imgBlock" :src="advert" />
      <div class="topmoney whiteB relativeItem">
        <p>邀请获取(个)：</p>
        <p class="money">{{ totalProfit }}</p>
        <router-link
          class="shouyiInvA absoluteItem centerY radius3"
          to="/invateNew"
          >赚获取</router-link
        >
      </div>
    </div>

    <!--滑动区域-->
    <div
      class="main"
      :style="padding_top"
      v-show="padding_top.paddingTop != '0px'"
    >
      <!--选项-->
      <div class="topBlank relativeItem whiteB">
        <span :class="{ active: see == 0 }" @click="see = 0">获取记录</span>
        <div class="title topFixed absoluteItem flex-box">
          <div class="qh flex-box">
            <p :class="{ active: see == 0 }" @click="click_getList(0)">
              获取记录
              <span v-show="see == 0"></span>
            </p>
            <p :class="{ active: see == 1 }" @click="click_getList(1)">
              我的邀请
              <span v-show="see == 1"></span>
            </p>
          </div>

          <div class="s whiteB" v-show="see == 0">
            <p class="num">{{ yqData.money }}</p>
            <p>今日获取(个)</p>
            <!-- <span class="num">{{ yqData.money }}</span> -->
          </div>

          <div class="s mine whiteB flex-box" v-show="see == 1">
            <div>
              <!-- <span class="num">{{ hyData.userNumber }}</span> -->
              <p class="num">{{ hyData.userNumber }}</p>
              <p>今日邀请</p>
            </div>
            <div>
              <!-- <span class="num">{{ hyData.userTotalNumber }}</span> -->
              <p class="num">{{ hyData.userTotalNumber }}</p>
              <p>累计邀请</p>
            </div>
          </div>
        </div>
      </div>

      <!--列表-->
      <ul class="u1 whiteB" v-show="see == 0">
        <li class="relativeItem" v-for="(n, index) in listO" :key="index">
          <!-- <p class="p1 apostrophe">{{ n.nickname }} 得到获取</p>
          <p class="p2">{{ n.current }}</p>
          <span class="money absoluteItem centerY">+{{ n.profit }}</span>-->
          <p class="p1 apostrophe">{{ n.current }}</p>
          <p class="p2">{{ n.nickname }}</p>
          <span class="money absoluteItem centerY">+{{ n.profit }}</span>
        </li>
      </ul>

      <ul class="u2 whiteB" v-show="see == 1">
        <li class="relativeItem" v-for="(n, cx) in listS" :key="cx">
          <!-- <img class="imgBloak absoluteItem centerY radius50" v-lazy="n.avatar" />
          <p class="p1 apostrophe">{{ n.nickname }}</p>
          <p class="p2">{{ n.current }}</p>
          <span
            class="money absoluteItem centerY"
            :class="{ red : n.time*1 <= 7 }"
          >剩余{{ n.time }}天解除</span>-->

          <img
            class="imgBloak absoluteItem centerY radius50"
            src="../../assets/blankimgcover.jpg"
          />
          <p class="p1 apostrophe">{{ n.nickname }}</p>
          <p class="p2">{{ n.money }}</p>
          <span
            class="money absoluteItem centerY"
            :class="{ red: n.time * 1 <= 7 }"
            >剩余{{ n.time }}天解除</span
          >
        </li>
      </ul>

      <!--空白-->
      <blank message="暂无信息" v-if="blank"></blank>
      <!--空白文本组件-->
      <blanktext v-if="blankText"></blanktext>
    </div>
  </div>
</template>

<script>
import blank from "./blank";
import blanktext from "./blankText";

export default {
  name: "shouyiInv",
  components: {
    blank,
    blanktext,
  },
  data() {
    return {
      totalProfit: null, //总获取
      advert: "", //广告图
      surplusProfit: null, //剩余提现金额
      yqData: [], //邀请获取额外数据
      hyData: [], //我的好友额外数据
      see: 0,
      blank: false,
      blankText: false,
      page: 1,
      ismore: true,
      listO: [], //获取记录
      listS: [], //邀请列表
      scroll: true, //当前页面是否允许加载等多
      scroll_able: true, //是否可以出发上拉加载的标识
      click_able:true,
      padding_top: {
        paddingTop: "0px",
      },
    };
  },
  methods: {
    /**下拉加载更多 */
    getMore: function() {
      var _this = this;
      let f = document.querySelector(".main");
      let top = f.scrollTop;
      let c = this.$tool.getByC("title")[0];
      let cb = this.$tool.getByC("topBlank")[0];
      let topshell = document.querySelector("#topshell");
      f.addEventListener("scroll", function(e) {
        if (!_this.scroll) {
          return;
        }

        top = e.target.scrollTop;
        let s = f.scrollHeight - top - f.offsetHeight <= 50;
        if (s && _this.ismore && _this.scroll_able) {
          _this.scroll_able = false;
          _this.page++;
          _this.getList();
        }
        //设置排序按钮的位置
        _this.topCondition(e, c, cb, topshell);
      });
    },

    /**滑动时控制列表选项的位置 */
    topCondition(e, c, cb, topshell) {
      if (cb == undefined) {
        return;
      }
      if (cb.offsetTop - e.target.scrollTop <= 0) {
        c.classList.add("conditionTop");
      } else if (cb.offsetTop - e.target.scrollTop > 0) {
        c.classList.remove("conditionTop");
      }

      if (e.target.scrollTop <= 8) {
        topshell.style.zIndex = "2";
      } else {
        topshell.style.zIndex = "0";
      }
    },
    //获取列表
    getList() {
      let _this = this;
      let data = {
        start: _this.page,
      };
      let api = null;
      if (this.see == 0) {
        api = "shouyijilv";
      } else {
        api = "friendsshouyi";
      }
      this.$jsonp(this.$apis(api), data, (res) => {
        _this.totalProfit = res.data.data.data.totalProfit;
        _this.advert = res.data.data.data.advert;
        _this.surplusProfit = res.data.data.data.surplusProfit;
        if (_this.see == 0) {
          _this.yqData = res.data.data.data;
        } else {
          _this.hyData = res.data.data.data;
        }
        //判断是否有数据
        let ls = res.data.data.data.details;
        if (ls.length > 0) {
          //有记录
          if (ls.length > 0) {
            _this.ismore = true;
            for (var i = 0; i < ls.length; i++) {
              if (_this.see == 0) {
                //邀请获取
                _this.listO.push(ls[i]);
              } else {
                //我的好友
                _this.listS.push(ls[i]);
              }
            }
          } else {
            //记录请求完
            _this.ismore = false;
            _this.blankText = true;
          }
        } else {
          //没有任何记录
          _this.ismore = false;
          if (_this.page == 1) {
            _this.blank = true;
          } else {
            _this.blankText = true;
          }
        }
        _this.scroll_able = true;
        _this.click_able = true;
      });
    },

    // 获取记录请求
    click_getList(see) {
      if (!this.click_able) {
        return false;
      }
      this.click_able = false;
      this.see = see;
      this.page = 1;
      this.ismore = true;
      this.blank = false;
      this.blankText = false;
      this.listO = [];
      this.listS = [];
      let _this = this;
      setTimeout(() => {
        _this.getList();
      }, 200);
    },

    /**设置滑块的padding-top */
    set_padding_top() {
      let _this = this;
      setTimeout(() => {
        let h = document.querySelector("#topshell").offsetHeight;
        _this.padding_top.paddingTop = h + 8 + "px";
      }, 1000);
    },
  },
  mounted: function() {
    this.$tool.setTitle("邀请获取");
    this.getMore();
    this.set_padding_top();
    this.getList();
  },
  beforeDestroy() {
    this.scroll = false;
  },
};
</script>

<style scoped>
#shouyiInv {
  margin-bottom: 3rem;
}
.topmoney {
  padding: 0.7rem;
  font-size: 15px;
  margin-bottom: 0.5rem;
}
.topmoney * {
  vertical-align: middle;
}
.money {
  margin-top: 3px;
  font-size: 22px;
  font-weight: bold;
  font-family: kefu;
}
.shouyiInvA {
  display: inline-block;
  right: 1rem;
  color: #fff;
  font-size: 12px;
  padding: 0.3rem 0.7rem;
  background: -webkit-linear-gradient(left, #ffca53, #ff7047);
  background: linear-gradient(to right, #ffca53, #ff7047);
}

/*列表*/
#topshell {
  position: relative;
  z-index: 2;
}
.main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  z-index: 1;
}
.topBlank {
  height: 64px;
}
.title {
  justify-content: space-between;
  background: white;
  height: 64px;
  align-items: center;
  padding: 0 16px;
}
.qh {
  align-items: center;
  font-size: 13px;
  color: #999;
}
.qh p {
  margin-right: 17px;
  text-align: center;
}
.qh .active {
  font-size: 20px;
  color: #333;
}
.qh span {
  display: block;
  width: 8px;
  height: 3px;
  border-radius: 3px;
  background: #333;
  margin: 0 auto;
  margin-top: 5px;
}
.s {
  font-size: 12px;
  border-left: 0;
  border-right: 0;
  text-align: right;
}
.mine {
  text-align: center;
}
.s .num {
  font-size: 18px;
  font-weight: bold;
  font-family: kefu;
  margin-bottom: 4px;
}
.s div {
  margin-left: 15px;
}
.p1 {
  max-width: 70%;
  margin-bottom: 0.25rem;
}
li {
  padding: 15px 16px;
  border-top: 1px solid #f4f4f4;
}
.u1 .p1 {
  font-size: 12px;
  color: #999;
}
.u1 .p2 {
  font-size: 14px;
}
.u1 span {
  right: 16px;
  font-size: 15px;
  font-weight: bold;
  font-family: kefu;
}

.u2 img {
  left: 0.5rem;
  width: 40px;
  height: 40px;
}
.u2 li {
  padding-left: 3.5rem;
}
.u2 .p1 {
  font-size: 14px;
  font-weight: bold;
}
.u2 .p2 {
  font-size: 12px;
  color: #999;
}
.u2 span {
  font-weight: 400;
  right: 0.5rem;
  font-size: 13px;
}
.u2 .red {
  color: #ff7979;
}
</style>
